import { createFileRoute } from '@tanstack/react-router';
import { Login } from '../../components/auth/Login';

export const Route = createFileRoute('/auth/login')({
  component: Login,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      resetSuccess:
        search.resetSuccess === true || search.resetSuccess === 'true'
          ? true
          : undefined,
    };
  },
});
